import React from 'react';
import {IProduct} from 'data/interfaces/products';
import HotelImageSquare from '../hotelImageSquare';
import AdDateBetween
  from 'gui/components/listPage/components/ad/components/adDateBetween/AdDateBetween';
import AdRoomSize
  from 'gui/components/listPage/components/ad/components/adRoomSize/AdRoomSize';
import AdStreet
  from 'gui/components/listPage/components/ad/components/adStreet/AdStreet';
import AdCardStructureContainer from 'data/redux/containers/adCardStructureContainer';
import AdRoomsAmount
  from 'gui/components/listPage/components/ad/components/adRoomsAmount';
import {generateNameWithDelimeter} from 'data/utils/calculators';
import { getPlaceDetails } from 'data/redux/selectors/productSelector';

interface IAdProps {
  product: IProduct;

  view?: (id: number) => void
  edit?: (id: number) => void
  delete?: (id: number) => void
}

export const generateHotelTitle = props => {
  const placeDetails = getPlaceDetails(props.product);
  if (props.product.hotelDetails.hotel) {
    return generateNameWithDelimeter(", ",
      props.product.hotelDetails.hotel.city,
      props.product.hotelDetails.hotel.country,
      props.product.hotelDetails.hotel.name
    );
  }
  return "";
};
const AdHotel = (props: IAdProps) => (
  <AdCardStructureContainer
    displaySquare={HotelImageSquare}
    cardTitle={generateHotelTitle(props)}
    specialDetails={<>
      <AdDateBetween
        startDate={props.product.hotelDetails.checkInDate}
        endDate={props.product.hotelDetails.checkOutDate}
      />
      <AdRoomsAmount
        roomsAmount={props.product.hotelDetails.roomsAmount}
      />
      <AdRoomSize
        people={props.product.hotelDetails.roomPeopleAmount}
      />
      <AdStreet placeDetails={Array.isArray(props.product.placeDetails) && props.product.placeDetails[0]}/>
    </>}
    salePriceLabel="מחיר כולל"
    timeRemaining={props.product.hotelDetails.checkInDate}
    originalPrice={props.product.hotelDetails.totalHotelPaidPrice}

    {...props}
  />
);

AdHotel.defaultProps = {
  product: {},


  hideControl: false,
  hideStatus: false,
  view: () => {
  },
  edit: () => {
  },
  delete: () => {
  },
};
export default AdHotel;
